var render, staticRenderFns
import script from "./video-player.vue?vue&type=script&lang=js"
export * from "./video-player.vue?vue&type=script&lang=js"
import style0 from "./video-player.vue?vue&type=style&index=0&id=30b855b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports